// extracted by mini-css-extract-plugin
export default {"root__container":"AccountStatus_root__container__Ruq58","title__home":"AccountStatus_title__home__71Hj7"};